import http from '@/utils/http-common'
import Swal from 'sweetalert2'
import router from '@/router'
import { refreshAccessTokenAsMethodRecall } from '@/utils/auth-service'

function methodRecall() { // main.js, mutations.js, actions.js, index.js(router) 공유
  return refreshAccessTokenAsMethodRecall();
}

export default {
  // user_info 전체를 갱신하고 서버에 저장
  async updateUserInfo({ commit, dispatch }, payload) {
    console.log('updateUserInfo', payload)
    commit('SET_USER_INFO', payload)
    await dispatch('syncUserSortJsonToServer')
  },
  // sort_json 특정 값만 변경하고 서버에 저장 (가장 자주 쓸 것)
  async updateUserSortValue({ commit, dispatch }, { key, value }) {
    console.log('updateUserSortValue', { key, value })
    commit('SET_USER_SORT_VALUE', { key, value })
    await dispatch('syncUserSortJsonToServer')
  },
  // sort_json 저장
  async syncUserSortJsonToServer({ state, getters, commit }) {
    console.log('syncUserSortJsonToServer')
    // 토큰 없으면 로그아웃 + 이동
    if (!state.access_token) {
      console.log('토큰 없으면 로그아웃 + 이동')
      commit('logout')
      router.push('/').catch(() => {})
      return
    }

    const userId = state.user_info?.pk || state.user_info?.id
    if (!userId) {
      console.log('userId 없음')
      return
    }

    const body = { sort_json: state.user_info?.sort_json || {} }
    console.log('syncUserSortJsonToServer body', body)
    const makeHeaders = () => ({ Authorization: 'Bearer ' + state.access_token })

    try {
      await http.put(`account/user/${userId}/`, body, { headers: makeHeaders() })
    } catch (err) {
      if (err?.response?.status !== 401) throw err

      // access token 만료 → recall 후 재시도
      try {
        const msg = await methodRecall()
        console.log(msg)
        // methodRecall 내부에서 state.access_token 갱신된다고 가정(기존 로직 그대로)
        await http.put(`account/user/${userId}/`, body, { headers: makeHeaders() })
      } catch (err_msg) {
        if (err_msg === 0) {
          // BE에 access token 저장 실패
          console.log('BE에 access token 저장 실패')
          return
        }

        // refresh token 만료
        Swal.mixin({
          toast: true,
          showClass: { popup: 'animate__animated animate__fadeInDown' },
          hideClass: { popup: 'animate__animated animate__fadeOutUp' },
          position: 'top',
          showConfirmButton: false,
          showCloseButton: true,
          timer: getters.toastTimer,
          timerProgressBar: false,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        }).fire({
          icon: 'warning',
          iconColor: '#ffc107',
          title: "<div style='font-size: 16px; color: #0D0E17'>다시 로그인해 주세요.<div>",
          width: getters.toastWidth,
          background: getters.toastBgColor,
        })

        commit('logout')
        router.push('/').catch(() => {})
      }
    }
  },
}
